export enum ButtonDisplayVariant {
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  PRODUCT_IMAGE = "PRODUCT_IMAGE",
  PRODUCT_IMAGE_LEFT = "PRODUCT_IMAGE_LEFT",
  PRODUCT_IMAGE_SIMPLIFIED = "PRODUCT_IMAGE_SIMPLIFIED",
  PRODUCT_IMAGE_SIMPLIFIED_LEFT = "PRODUCT_IMAGE_SIMPLIFIED_LEFT",
}

export enum ButtonIcon {
  TINT_LOGO = "TINT_LOGO",
  GLASSES = "GLASSES",
  EYE = "EYE",
  CAMERA = "CAMERA",
  CAMERA_BLACK = "CAMERA_BLACK",
  MIRROR = "MIRROR",
  SPARKLE = "SPARKLE",
}

export interface ButtonCustomization {
  buttonDisplayVariant: ButtonDisplayVariant
  buttonColor: string
  buttonText: string
  buttonIcon: ButtonIcon
  showButtonText: boolean
  hasNoIcon: boolean
  iconTextSameLine: boolean
  textColor: string
  borderRadius?: string
  borderWidth?: string
  borderColor?: string
}

export const DEFAULT_BUTTON_COLOR = "#000000"
export const DEFAULT_BUTTON_TEXT = ""
export const DEFAULT_BUTTON_ICON = ButtonIcon.TINT_LOGO
export const DEFAULT_SHOW_BUTTON_TEXT = true
export const DEFAULT_HAS_NO_ICON = false
export const DEFAULT_ICON_TEXT_SAME_LINE = false
export const DEFAULT_TEXT_COLOR = "#FFFFFF"
export const DEFAULT_BORDER_RADIUS = ""
export const DEFAULT_BORDER_WIDTH = ""
export const DEFAULT_BORDER_COLOR = ""
